<template>
  <article>
    <section class="xbed-sub-title">
      <span>房型详情</span>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="渠道房型信息" name="roomTypeInfo" ref="roomTypeInfo">
        <Form label-position="left" class="room-type-info" :label-width="110">
          <FormItem label="渠道门店ID：" prop="title">
            <span>{{ roomTypeInfo.channelHotelId }}</span>
          </FormItem>
          <FormItem label="渠道门店名称：" prop="title">
            <span>{{ roomTypeInfo.channelHotelName }}</span>
          </FormItem>
          <FormItem label="渠道房型id：" prop="title">
            <span>{{ roomTypeInfo.roomTypeId }}</span>
          </FormItem>
          <FormItem label="渠道房型名称：" prop="title">
            <span>{{ roomTypeInfo.roomTypeId }}</span>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="打包信息" name="packageInfo" ref="packageInfo">
        <Form label-position="left" class="room-type-info" :label-width="110">
          <FormItem label="取价房间ID：" prop="title">
            <span>{{ packageInfo.unifyPriceRoomId }}</span>
          </FormItem>
          <FormItem label="取价房间名称：" prop="title">
            <span>{{ packageInfo.unifyPriceRoom }}</span>
          </FormItem>
          <FormItem label="打包房数：" prop="title">
            <span>{{ packageInfo.packageCount }}</span>
          </FormItem>
          <FormItem label="有效房数：" prop="title">
            <span>{{ packageInfo.validCount }}</span>
          </FormItem>
          <FormItem label="本日可用房量：" prop="title">
            <span>{{ packageInfo.availableCount }}</span>
          </FormItem>
          <FormItem label="缓存房量：" prop="title">
            <span>{{ packageInfo.bufferCount }}</span>
          </FormItem>
          <FormItem label="本日渠道剩余可用房量：" prop="title">
            <span>{{ packageInfo.remainCount }}</span>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="打包列表" name="pkgRoomList" ref="pkgRoomList" style="margin-left: 1px;">
        <Form  @submit.native.prevent="preventSubmit" :model="pkgRoomList.form" inline>
          <FormItem prop="name" label="楼宇ID：" :label-width="80">
            <Input type="text" v-model="pkgRoomList.form.buildingId" placeholder="查询楼宇ID"></Input>
          </FormItem>
          <FormItem prop="name" label="房间名称：" :label-width="84">
            <Input type="text" v-model="pkgRoomList.form.name" placeholder="查询房间名称"></Input>
          </FormItem>
          <FormItem prop="name" label="房号：" :label-width="60">
            <Input type="text" v-model="pkgRoomList.form.roomNo" placeholder="查询房号"></Input>
          </FormItem>
          <FormItem prop="pkgRoomQuery">
            <Button type="primary" @click="queryWithKeyword">查询</Button>
          </FormItem>
          <FormItem prop="addPkgRoom">
            <Button @click="queryUnbindRoomList" type="primary">新增打包</Button>
          </FormItem>
        </Form>
        <Table stripe :loading="pkgRoomList.loading" height="450" :columns="pkgRoomList.columns" :data="pkgRoomList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="pkgRoomList.count" :current="pkgRoomList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
    </Tabs>

    <Modal v-model="unbindRoomTypeList.display" ref="addPkgModal" :loading="true" :width="1100" title="未打包房间列表" @on-ok="prepareAddPkgRoomType" @on-cancel="cancelAddPkgRoomType" ok-text="确定打包" cancel-text="取消">
      <Form :model="unbindRoomTypeList.form" @submit.native.prevent="preventSubmit" inline>
        <FormItem  label="查询：" prop="modalKeyWord" :label-width="60">
          <Input type="text" v-model="unbindRoomTypeList.form.keyword" placeholder="查询关键字"></Input>
        </FormItem>
        <FormItem prop="modalQuery">
          <Button type="primary" @click="queryModalDataWithKeyword">查询</Button>
        </FormItem>
        <FormItem prop="modalAllSelect">
          <Button type="primary" @click="selectedAll">全选</Button>
        </FormItem>
        <FormItem prop="modalAntiSelect">
          <Button type="primary" @click="antiSelected">反选</Button>
        </FormItem>
      </Form>
      <Table stripe ref="modalSelection" :loading="unbindRoomTypeList.loading" @on-selection-change="selectedChangeWithRow" :columns="unbindRoomTypeList.columns" :data="unbindRoomTypeList.displayData"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="unbindRoomTypeList.count" :current="unbindRoomTypeList.page" @on-page-size-change="changeModalPageSize" @on-change="changeModalPage"></Page>
      </div>
      <Row>
        <Col>{{`共${unbindRoomTypeList.filterDataList.length}房，已选择${unbindRoomTypeList.selectedRoomType.size}房`}}</Col>
      </Row>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.roomTypeId = Utils.getUrlParameterByName("roomTypeId");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      currTabName: "roomTypeInfo",
      roomTypeInfo: {
        channelHotelId: '',
        channelHotelName: '',
        roomTypeId: '',
        name: ''
      },
      packageInfo: {
        unifyPriceRoomId: '',
        unifyPriceRoom: '',
        packageCount: '',
        validCount: '',
        availableCount: '',
        bufferCount: '',
        remainCount: ''
      },
      pkgRoomList: {
        columns: [
          {
            title: "楼宇ID",
            key: "buildingId",
            align: "center",
            width: 100
          },
          {
            title: "房间ID",
            key: "roomId",
            align: "center",
            width: 100
          },
          {
            title: "房间名称",
            key: "custRoomName",
            align: "center",
            width: 250
          },
          {
            title: "户型",
            key: "houseType",
            align: "center",
            width: 150
          },
          {
            title: "床型",
            key: "bedDescribe",
            align: "center",
            width: 150
          },
          {
            title: "楼层",
            key: "roomFloor",
            align: "center",
            width: 150
          },
          {
            title: "房号",
            key: "custRoomNo",
            align: "center",
            width: 150
          },
          {
            title: "销售状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = "";
              switch(params.row.status) {
                case "S01":
                status = "在售";
                break;
                case "S02":
                status = "下架";
                break;
              }
              return h("div", {}, status);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定取消打包此房间？该房间将恢复独立销售`;
                            return modalH("div", {
                              style: {
                                fontSize: "16px",
                              },
                            }, modalText)
                          },
                          onOk: () => {
                            // TODO: 删除打包
                            this.removeRoomToRoomType(params.index);
                          }
                        })
                      }
                    }
                  },
                  "删除打包"
                )
              ]);
            }
          }
        ],
        form: {
          buildingId: '',
          name: '',
          roomNo: ''
        },
        loading: false,
        data: [],
        count: 0,
        page: 1,
        pageSize: 10,
      },
      unbindRoomTypeList: {
        display: false,
        form: {
          keyword: ''
        },
        loading: false,
        key: {
          flag: {
            1: "销售中",
            2: "删除",
            3: "下架",
            4: "筹建中",
            5: "售前展示"
          },
          tagCode: {
            "2001": "短租",
            "2002": "长租",
          },
        },
        columns: [
          {
            type: 'selection',
            width: 80,
            align: 'center'
          },
          {
            title: "楼宇ID",
            key: "buildingId",
            align: "center",
            width: 160
          },
          {
            title: "楼层",
            key: "roomFloor",
            align: "center",
            width: 160
          },
          {
            title: "房间ID",
            key: "roomId",
            align: "center",
            width: 160
          },
          {
            title: "房间名称",
            key: "custRoomName",
            align: "center",
            width: 160
          },
          {
            title: "户型",
            key: "houseType",
            align: "center",
            width: 160
          },
          {
            title: "床型",
            key: "bedDescribe",
            align: "center",
            width: 160
          },
        ],
        page: 1,
        pageSize: 10,
        count: 0,
        data: [],
        displayData: [],
        filterDataList: [],
        selectedRoomType: new Set()
      }
    }
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.queryRoomTypeData();
    },
    queryRoomTypeData() {
      if (this.currTabName == "pkgRoomList") {
        this.queryRoomTypeList();
      } else {
        this.queryBaseInfo();
      }
    },
    async queryBaseInfo() {
      let resp = (await this.queryRoomTypeInfo(
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      this.roomTypeInfo = Object.assign(this.roomTypeInfo, resp.channelRoomType);
      this.packageInfo = Object.assign(this.packageInfo, resp.packageInfo);

    },
    queryRoomTypeInfo(token, env) {
      return API.omsAPI[env].ota.queryRoomTypeInfo(
        this.roomTypeId,
        token
      );
    },
    changePage(pageIndex) {
      this.pkgRoomList.page = pageIndex;
      // this.queryRoomTypeList();
    },
    changePageSize(pageSize) {
      this.pkgRoomList.page = 1;
      this.pkgRoomList.pageSize = pageSize;
      // this.queryRoomTypeList();
    },
    async queryRoomTypeList() {
      this.pkgRoomList.loading = true;
      const resp = (await this.queryRoomList(
        this.pkgRoomList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }

      this.pkgRoomList.data = resp.list;
      this.pkgRoomList.count = resp.rowCount;
      this.pkgRoomList.loading = false;
    },
    queryRoomList(roomList, token, env) {
      let buildingId = this.pkgRoomList.form.buildingId ? this.pkgRoomList.form.buildingId : null;
      let roomNo = this.pkgRoomList.form.roomNo ? this.pkgRoomList.form.roomNo : null;

      return API.omsAPI[env].ota.queryRoomList(
        buildingId,
        roomList.page,
        this.pkgRoomList.form.name,
        roomNo,
        this.roomTypeId,
        roomList.pageSize,
        token
      );
    },
    queryWithKeyword(){
      this.pkgRoomList.page = 1;
      this.queryRoomTypeData();
    },
    // 查询未打包房间列表
    async queryUnbindRoomList() {
      this.unbindRoomTypeList.display = true;
      this.unbindRoomTypeList.loading = true;
      let resp = (await this.queryRoomTypeModalListWithUnbind(this.roomTypeId, this.token, this.env)).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      resp.roomList.forEach(room => {
        room.tagCode = room.tagCode.split(',').length == 2 ? "长租，短租" : this.unbindRoomTypeList.key.tagCode[room.tagCode] || "";
        room.flag = this.unbindRoomTypeList.key.flag[room.flag] || "";
      })
      this.unbindRoomTypeList.data = resp.roomList;
      this.unbindRoomTypeList.count = resp.roomList.length;
      this.unbindRoomTypeList.pageCount = (this.unbindRoomTypeList.count % this.unbindRoomTypeList.page) == 0 ? (this.unbindRoomTypeList.count / this.unbindRoomTypeList.page) : (this.unbindRoomTypeList.count / this.unbindRoomTypeList.page + 1)
      this.unbindRoomTypeList.filterDataList = this.unbindRoomTypeList.data;
      this.displayUnbindRoomList();
      this.unbindRoomTypeList.loading = false;
    },
    queryRoomTypeModalListWithUnbind(roomTypeId, token, env) {
      return API.omsAPI[env].ota.queryUnbindRoomList(
        roomTypeId,
        token
      )
    },
    changeModalPage(pageIndex) {
      this.unbindRoomTypeList.page = pageIndex;
      this.displayUnbindRoomList();

      this.$nextTick(function () {
        this.selectedChange();
      })
    },
    changeModalPageSize(pageSize) {
      this.unbindRoomTypeList.page = 1;
      this.unbindRoomTypeList.pageSize = pageSize;
      this.displayUnbindRoomList();

      this.$nextTick(function () {
        this.selectedChange();
      })
    },
    // 展示当前页数的未打包房间
    displayUnbindRoomList() {
      let startIndex = (this.unbindRoomTypeList.page-1) * this.unbindRoomTypeList.pageSize;
      let endIndex = this.unbindRoomTypeList.pageSize * this.unbindRoomTypeList.page;
      this.unbindRoomTypeList.displayData = [];
      if (this.unbindRoomTypeList.count<=5) {
        this.unbindRoomTypeList.displayData = this.unbindRoomTypeList.filterDataList
      } else {
        let filterDataList = [];
        for (let i=startIndex; i<endIndex; i++) {
          if (!this.unbindRoomTypeList.filterDataList[i]) break;
          filterDataList.push(this.unbindRoomTypeList.filterDataList[i]);
        }
        this.unbindRoomTypeList.displayData = filterDataList;
      }
    },
    // 前端查询
    queryModalDataWithKeyword() {
      this.unbindRoomTypeList.loading = true;
      this.unbindRoomTypeList.filterDataList = this.filterModalDataWithKeyword();
      this.unbindRoomTypeList.page = 1;
      this.unbindRoomTypeList.count = this.unbindRoomTypeList.filterDataList.length;
      this.unbindRoomTypeList.pageCount = (this.unbindRoomTypeList.count % this.unbindRoomTypeList.filterDataList.length) == 0 ? (this.unbindRoomTypeList.count / this.unbindRoomTypeList.filterDataList.length) : (this.unbindRoomTypeList.count / this.unbindRoomTypeList.filterDataList.length + 1)
      this.displayUnbindRoomList();
      this.unbindRoomTypeList.loading = false;

      this.$nextTick(() => {
        this.selectedChange();
      })
    },
    // 前端筛选
    filterModalDataWithKeyword() {
      return this.unbindRoomTypeList.data.filter((room) => {
        let result = false;
        for (let itemKey in room) {
          if (this.skipKeyFromData(itemKey)) {
            continue;
          }
          let queryItem = '' + room[itemKey];
          if (queryItem.toUpperCase().indexOf((this.unbindRoomTypeList.form.keyword).toUpperCase()) !== -1) {
            result = true;
            break;
          }
        }
        return result;
      });
    },
    skipKeyFromData(key) {
      let isSkip = false;
      switch(key) {
        case 'businessTime':
        case 'bedDescribe':
        case 'createDate':
        case 'custRoomAddr':
        case 'defaultPrice':
        case 'district':
        case 'modiDate':
        case 'sort':
          isSkip = true;
          break;
      }
      return isSkip;
    },
    async prepareAddPkgRoomType() {
      if (this.unbindRoomTypeList.selectedRoomType.size == 0) {
        this.$Notice.error({
          title: "新增打包失败",
          desc: "未选择房型"
        });
        this.$refs.addPkgModal.buttonLoading = false;
        return;
      }
      // TODO: 新增房型
      let roomIds = Array.from(this.unbindRoomTypeList.selectedRoomType).toString()
      let resp = (await this.addRoomsToRoomType(this.username, roomIds, this.roomTypeId, this.token, this.env)).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.addPkgModal.buttonLoading = false;
        this.$Notice.error({
          title: "新增打包失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "新增打包成功"
        });
        this.unbindRoomTypeList.display = false;
        this.refreshTable();
        this.resetAddModalData();
      }
    },
    cancelAddPkgRoomType() {
      this.resetAddModalData();
    },
    addRoomsToRoomType(username, roomIds, roomTypeId, token, env) {
      return API.omsAPI[env].ota.addRoomsToRoomType(
        username,
        roomIds,
        roomTypeId,
        token
      )
    },
    async removeRoomToRoomType(index) {
      let room = this.pkgRoomList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeRoomToRoomType(
        room.roomId,
        this.roomTypeId,
        this.username,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除打包失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除打包成功"
        });

        this.pkgRoomList.data.splice(index, 1);
        this.queryRoomTypeList();
      }
    },
    // 单行选择
    selectedChangeWithRow() {
      let length = Object.keys(this.$refs.modalSelection.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.modalSelection.objData[i].roomId;
        let isChecked = this.$refs.modalSelection.objData[i]._isChecked;
        if (!isChecked&&this.unbindRoomTypeList.selectedRoomType.has(roomId)) {
          this.unbindRoomTypeList.selectedRoomType.delete(roomId);
        } else if (isChecked&&!this.unbindRoomTypeList.selectedRoomType.has(roomId)) {
          this.unbindRoomTypeList.selectedRoomType.add(roomId);
        }
      }
      this.updateModalSelectedRoomType();
    },
    // 选择全部
    selectedAll() {
      for (let i=0; i<this.unbindRoomTypeList.filterDataList.length; i++) {
        this.unbindRoomTypeList.selectedRoomType.add(this.unbindRoomTypeList.filterDataList[i].roomId);
      }
      this.selectedChange();
    },
    // 反选
    antiSelected() {
      for (let i=0; i<this.unbindRoomTypeList.filterDataList.length; i++) {
        let roomId = this.unbindRoomTypeList.filterDataList[i].roomId;
        if (this.unbindRoomTypeList.selectedRoomType.has(roomId)) {
          this.unbindRoomTypeList.selectedRoomType.delete(roomId);
        } else {
          this.unbindRoomTypeList.selectedRoomType.add(roomId);
        }
      }
      this.selectedChange();
    },
    // 选择后样式变化
    selectedChange() {
      let length = Object.keys(this.$refs.modalSelection.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.modalSelection.objData[i].roomId;
        if (this.unbindRoomTypeList.selectedRoomType.has(roomId)) {
          this.$refs.modalSelection.objData[i]._isChecked = true;
        } else {
          this.$refs.modalSelection.objData[i]._isChecked = false;
        }
      }
      this.updateModalSelectedRoomType();
    },
    // 更新选择未打包房间的数据
    updateModalSelectedRoomType() {
      this.unbindRoomTypeList.selectedRoomType = new Set(this.unbindRoomTypeList.selectedRoomType);
    },
    resetPkgRoomList() {
      this.pkgRoomList = Object.assign({}, this.pkgRoomList, {
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      })
    },
    resetAddModalData() {
      this.unbindRoomTypeList = Object.assign({}, this.unbindRoomTypeList, {
        count: 0, //记录总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        selectedRoomType: new Set(),
        form: {
          keyword: ''
        }
      })
    },
    refreshTable() {
      this.resetPkgRoomList();
      this.queryRoomTypeList();
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
}
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}

.text-align-right {
  text-align: right;
}

.room-type-info {
  padding: 20px;
  span {
    line-height: 34px;
    font-size: 14px;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/ota/elong-roomtype-detail.vue